import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from '../../../../UiKit';
import styled from 'styled-components';
import { OrderTagDetailsModal } from './OrderTagDetailsModal';
import { ChevronRight } from 'sushiweb/Icons';
import { ToolTip } from '../../../ComponentsV1/ToolTip/Tooltip';
import { Info } from 'lucide-react';

const OrderTags = (props) => {
  const { order, maxTags = 4 } = props;

  const MAX_VISIBLE_TAGS = maxTags;
  const [orderTagDetailsPopUp, setOrderTagDetailsPopUp] = useState();
  const [orderTagPopUpInfo, setOrderTagPopUpInfo] = useState();
  const tagsList = useSelector((state) => state.tagsState?.tagsList);
  if (!order) return null;

  const hasAccessibilityTag = tagsList?.[order?.order_id]?.some(
    (tag) => tag.title === 'Accessibility enabled',
  );

  const OrderTags = [
    ...(order?.order_tags || []),
    ...(order?.resolved_issue_count > 0
      ? [
          {
            text: `Resolved Issues : ${order.resolved_issue_count}`,
            bg_color: 'brown',
            color: 'white',
          },
        ]
      : []),
    ...(hasAccessibilityTag
      ? [
          {
            text: 'Specially Abled',
            bg_color: '#F3E8FD',
            color: '#7B1FA2',
          },
        ]
      : []),
  ];

  const handleTagDetailsPopup = (tag) => {
    if (tag?.meta?.data) {
      setOrderTagDetailsPopUp((prevState) => !prevState);
      setOrderTagPopUpInfo(tag.meta);
    }
  };

  const closeOrderTagPopUp = () => setOrderTagDetailsPopUp(false);

  const ShowTagLabel = ({ texts }) => {
    if (!texts || texts.length === 0) return null;

    return (
      <div
        css={`
          display: flex;
          flex-direction: column;
        `}
      >
        {texts.map((text) => (
          <div key={text}>{text}</div>
        ))}
      </div>
    );
  };

  return (
    <div className='tw-flex tw-items-center tw-gap-2 tw-w-full tw-h-full'>
      <div className='tw-flex tw-h-10'>
        {OrderTags?.length > 0 ? (
          <div className='tagToolTip tw-flex tw-items-center tw-gap-[6px] tw-h-[2.6rem]'>
            {OrderTags?.slice(0, MAX_VISIBLE_TAGS)?.map((tag, index) => {
              if (!tag) return null;
              if (tag.image) {
                return (
                  <OrderImageTag key={tag.text || tag.image}>
                    <img
                      src={tag.image}
                      height='100%'
                      width='100%'
                      alt={tag.text || 'tag-image'}
                    />
                  </OrderImageTag>
                );
              }
              return (
                <Tooltip
                  key={tag.text}
                  position='bottom'
                  border={false}
                  title={
                    <OrderTag
                      key={index}
                      bgColor={tag.bg_color}
                      textColor={tag.color}
                      onClick={() => {
                        handleTagDetailsPopup(tag);
                      }}
                      showHoverPointer={!!tag.meta?.data}
                      showArrow={
                        tag?.hover_texts?.length > 0
                          ? true
                          : false || !!tag.meta?.data
                      }
                    >
                      {tag.text}
                    </OrderTag>
                  }
                  label={
                    tag?.hover_texts?.length > 0 ? (
                      <ShowTagLabel texts={tag.hover_texts} />
                    ) : (
                      ''
                    )
                  }
                />
              );
            })}
          </div>
        ) : null}
      </div>

      {/* "+more" Button */}
      {OrderTags.length > MAX_VISIBLE_TAGS && (
        <ToolTip
          withArrow={false}
          className='!tw-bg-white tw-w-full'
          placement='bottom'
          closeDelay={500}
          content={
            <div>
              {OrderTags?.length > 0 ? (
                <div className='tw-flex tw-gap-2 tw-flex-wrap tw-w-full'>
                  {OrderTags.slice(MAX_VISIBLE_TAGS).map((tag, index) => {
                    if (!tag) return null;
                    if (tag.image) {
                      if (tag.text === 'Unicorn') {
                        return (
                          <div className='tw-h-10 tw-w-fit' key={tag.text}>
                            <OrderTag
                              key={index}
                              bgColor={tag.bg_color}
                              textColor={tag.color}
                              onClick={() => {
                                handleTagDetailsPopup(tag);
                              }}
                              showHoverPointer={!!tag.meta?.data}
                              showArrow={
                                tag?.hover_texts?.length > 0
                                  ? true
                                  : false || !!tag.meta?.data
                              }
                            >
                              <span className='tw-text-[1.5rem] tw-mr-1'>
                                
                              </span>
                              Apple
                            </OrderTag>
                          </div>
                        );
                      }
                      return (
                        <div className='tw-h-10' key={tag.image || tag.text}>
                          <img
                            src={tag.image}
                            className='tw-h-full tw-w-auto tw-object-contain'
                            alt={tag.text || 'tag-image'}
                          />
                        </div>
                      );
                    }
                    return (
                      <div className='tw-h-10' key={tag.text}>
                        <ToolTip
                          content={
                            tag?.hover_texts?.length > 0 ? (
                              <ShowTagLabel texts={tag.hover_texts} />
                            ) : (
                              ''
                            )
                          }
                          disabled={!tag?.hover_texts?.length}
                        >
                          <div className='tw-h-full tw-w-fit'>
                            <OrderTag
                              key={index}
                              bgColor={tag.bg_color}
                              textColor={tag.color}
                              onClick={() => {
                                handleTagDetailsPopup(tag);
                              }}
                              showHoverPointer={!!tag.meta?.data}
                              showArrow={
                                tag?.hover_texts?.length > 0
                                  ? true
                                  : false || !!tag.meta?.data
                              }
                            >
                              {tag.text}
                            </OrderTag>
                          </div>
                        </ToolTip>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
          }
        >
          <div>
            <OrderTag
              textColor='#318616'
              showHoverPointer={true}
              className='!tw-shadow-none hover:tw-bg-grey-200/70 tw-duration-200 tw-transition-all tw-ease-in-out'
            >
              + {OrderTags.length - MAX_VISIBLE_TAGS} more
            </OrderTag>
          </div>
        </ToolTip>
      )}

      {orderTagDetailsPopUp ? (
        <OrderTagDetailsModal
          handleClose={closeOrderTagPopUp}
          tagInfo={orderTagPopUpInfo}
        />
      ) : null}
    </div>
  );
};

export default OrderTags;

export const OrderTag = ({
  bgColor = 'bg-grey-200',
  textColor = 'text-white',
  showHoverPointer = false,
  showArrow = false,
  showInfoIcon = false,
  children,
  onClick = () => {},
  className = '',
}) => {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={`tw-h-full tw-min-w-fit tw-shadow-sm tw-justify-center tw-whitespace-nowrap ${
        showArrow ? 'tw-pl-3 tw-pr-2' : 'tw-px-3'
      } tw-py-1 tw-rounded-[4px] tw-text-[1.3rem] tw-font-medium tw-flex tw-items-center tw-gap-1 ${className}`}
      style={{
        backgroundColor: bgColor,
        color: textColor,
        cursor: showHoverPointer ? 'pointer' : 'default',
      }}
      onClick={onClick}
    >
      {children}
      {showArrow ? <ChevronRight size={16} color={textColor} /> : null}
      {showInfoIcon ? (
        <Info
          size={14}
          color={textColor}
          className='tw-mt-[0.5px] tw-ml-[2px] tw-text-zinc-600'
          strokeWidth={2.2}
        />
      ) : null}
    </div>
  );
};

const OrderImageTag = styled.div`
  height: 100%;
`;
